document.addEventListener('DOMContentLoaded', () => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Fade-in on scroll, staggered per row
  const reveals = document.querySelectorAll('.reveal');
  if (document.body.classList.contains('anim-reveal') && 'IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver((entries) => {
      entries.filter((e) => e.isIntersecting).forEach((e, i) => {
        e.target.style.setProperty('--d', (i * 0.08) + 's');
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  // On touch screens (no hover) switch between the two product images automatically
  const noHover = window.matchMedia('(hover: none)').matches;
  if (document.body.classList.contains('anim-cycle') && noHover && !reduce) {
    const cards = Array.from(document.querySelectorAll('.card--swap'));
    const visible = new Set();
    if ('IntersectionObserver' in window) {
      const vo = new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
      }, { threshold: 0.5 });
      cards.forEach((c) => vo.observe(c));
    }
    cards.forEach((c, i) => {
      setTimeout(() => {
        setInterval(() => { if (visible.has(c)) c.classList.toggle('is-alt'); }, 3200);
      }, i * 400);
    });
  }

  const swapMain = (src) => {
    const img = document.getElementById('MainImage');
    if (!img || !src) return;
    img.classList.add('is-fading');
    setTimeout(() => {
      img.removeAttribute('srcset');
      img.onload = () => img.classList.remove('is-fading');
      img.src = src;
      if (img.complete) img.classList.remove('is-fading');
    }, 250);
  };

  const select = document.getElementById('VariantSelect');
  const mainImage = () => document.getElementById('MainImage');

  if (select) {
    select.addEventListener('change', () => {
      const opt = select.options[select.selectedIndex];
      const sale = document.querySelector('#ProductPrice .price__sale');
      const compare = document.querySelector('#ProductPrice .price__compare');
      const btn = document.getElementById('AddToCart');
      if (sale) sale.textContent = opt.dataset.price;
      if (compare) {
        compare.textContent = opt.dataset.compare || '';
        compare.hidden = !opt.dataset.compare;
      }
      const available = opt.dataset.available === 'true';
      if (btn) { btn.disabled = !available; btn.textContent = available ? 'Add to cart' : 'Sold out'; }
      if (opt.dataset.image) swapMain(opt.dataset.image);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    });
  }

  document.querySelectorAll('.thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      swapMain(thumb.dataset.src);
      document.querySelectorAll('.thumb').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  const sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
});
